import { useState } from "react";

import { useQueryClient } from "@tanstack/react-query";

import useContacts from "../../data/useContacts";
import useDefaultCRUDHandlers from "../../hooks/useDefaultCRUDHandlers";
import Modal, { ModalProps } from "../../layouts/Modal";
import { IContact } from "../../models/Contact";
import { ContactCombobox } from "../contacts/ContactCombobox";
import { ButtonInput } from "../shared/Inputs/ButtonInput";

interface AccountContactAddModalProps
  extends Omit<ModalProps, "children" | "width"> {
  accountId: string;
}

export function AccountContactAddModal({
  open,
  setOpen,
  accountId,
}: AccountContactAddModalProps) {
  const queryClient = useQueryClient();
  const { update } = useContacts();
  const [selectedContact, setSelectedContact] = useState<IContact>();
  const { saveHandlers } = useDefaultCRUDHandlers("Account contact");

  const addContactToAccount = () => {
    if (!selectedContact) return;

    update.mutate(
      { ...selectedContact, accountId: accountId },
      {
        ...saveHandlers,
        onSuccess: () => {
          saveHandlers.onSuccess();
          queryClient.invalidateQueries({
            queryKey: ["accounts", accountId, "contacts"],
          });
          setOpen(false);
        },
      }
    );
  };

  return (
    <Modal width="max-w-2xl" open={open} setOpen={setOpen}>
      <h2 className="text-xl font-semibold mb-6">Add Contact</h2>
      <ContactCombobox onContactSelect={setSelectedContact} />
      <div className="mt-6 flex justify-end">
        <ButtonInput
          label="Add to Account"
          isSubmit={false}
          classes=""
          disabled={!selectedContact}
          onClick={addContactToAccount}
        />
      </div>
    </Modal>
  );
}
